import { RenderPass } from "@/core/pipeline/render-pass"
import { Texture } from "@/core/backends/webgl/texture"

export class RefineMaskPass extends RenderPass {
	public render(inputTexture: Texture, maskTexture: Texture, inflation = false) {
		const writeBuffer = this.renderer.dualBuffers.writeBuffer
		const readBuffer = this.renderer.dualBuffers.readBuffer

		const width = maskTexture.width
		const height = maskTexture.height

		writeBuffer.updateSize(width, height)
		readBuffer.updateSize(width, height)

		this.combine(inputTexture, maskTexture, writeBuffer)
		this.preprocess(writeBuffer, readBuffer, inflation)
		this.computeAB(readBuffer, writeBuffer)
		this.meanAB(writeBuffer, maskTexture)
	}

	private combine(inputTexture: Texture, maskTexture: Texture, out: Texture) {
		out.bindFramebuffer()

		inputTexture.bind(0)
		maskTexture.bind(1)

		this.renderer.shaders.refineMaskCombine.render({
			inputTexture: 0,
			inputMask: 1,
		})

		return out
	}

	private preprocess(inputTexture: Texture, out: Texture, inflation: boolean) {
		out.bindFramebuffer()

		inputTexture.bind(0)

		this.renderer.shaders.refineMaskPreprocess.render({
			inputTexture: 0,
			inflation: inflation,
		})

		return out
	}

	private computeAB(inputTexture: Texture, out: Texture) {
		out.bindFramebuffer()

		inputTexture.bind(0)

		this.renderer.shaders.refineMaskAB.render({
			inputTexture: 0,
			eps: 0.001,
			computeAB: true,
		})

		return out
	}

	private meanAB(inputTexture: Texture, out: Texture) {
		out.bindFramebuffer()

		inputTexture.bind(0)

		this.renderer.shaders.refineMaskAB.render({
			inputTexture: 0,
			computeAB: false,
		})

		return out
	}

	dispose() {
		return
	}
}
